/**
 * Messages
 */
const messages = require('../../messages');

/**
 * Repositories
 */
const permissionIdentities = require('../../permission-identities');

/**
 * Request schemas
 */
const requestSchemas = require('../../request-schemas');

/**
 * Scopes
 */
const scopes = require('../../scopes');

module.exports = [
  {
    action: 'getCustomerDealerFightsBySystemGameTypeId',
    message: messages.SUCCESS_GET_CUSTOMER_DEALER_FIGHTS_BY_SYSTEM_GAME_TYPE_ID,
    method: 'GET',
    path: '/customer/:customerId/dealer-fights/:systemGameTypeId',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.GET_CUSTOMER_DEALER_FIGHT,
    requestSchema: requestSchemas.customerDealerFights.getCustomerDealerFightsBySystemGameTypeId,
    scopes: [scopes.DEFAULT],
  },
  {
    action: 'updateCustomerDealerFightsBySystemGameTypeId',
    message: messages.SUCCESS_UPDATE_CUSTOMER_DEALER_FIGHTS_BY_SYSTEM_GAME_TYPE_ID,
    method: 'PATCH',
    path: '/customer/:customerId/dealer-fights/:systemGameTypeId',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.UPDATE_CUSTOMER_DEALER_FIGHT,
    requestSchema: requestSchemas.customerDealerFights.updateCustomerDealerFightsBySystemGameTypeId,
  },
];
